import { render, staticRenderFns } from "./kri.vue?vue&type=template&id=c3f7e4b2"
import script from "./kri.vue?vue&type=script&lang=js"
export * from "./kri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports